// extracted by mini-css-extract-plugin
export default {"svg":"DocsButton_svg__0diaj","div":"DocsButton_div__fpzJN"};